// extracted by mini-css-extract-plugin
export default {"rowBlock":"GridTwoElems_rowBlock__Id6Nm","rowBlockElem":"GridTwoElems_rowBlockElem__XS0tH","title":"GridTwoElems_title__GfKy0","text":"GridTwoElems_text__EFOps"};